<template>
  <div class="follow-up-task">
    <!-- 顶部概述区域 -->
    <div class="summary-section">
      <!-- 第一行 -->
      <div class="summary-row row">
        <div class="summary-item flex-1 mr10">
          <span class="label font-666">跟进目标:</span>
          <span class="value font-333">{{ self.goal }}</span>
        </div>
        <!-- 待跟进状态显示计划跟进时间 -->
        <div v-if="isPendingFollowUp" class="summary-item  text-right">
          <span class="label font-666">计划跟进时间:</span>
          <span class="value font-333">{{ self.followDate }}</span>
        </div>
        <!-- 已完成/已终止状态显示实际跟进时间 -->
        <div v-else class="summary-item  flex-center text-right ">
          <span class="label font-666">跟进时间:</span>
          <span class="value font-333 ">{{ self.followDate }}</span>
        </div>
      </div>
      <!-- 第二行 - 只在已完成/已终止状态显示 -->
      <div v-if="!isPendingFollowUp" class="summary-row row mt8">
        <div class="summary-item flex-1">
          <span class="label font-666">跟进人:</span>
          <span class="value font-333">{{ self.followEmployeeName }}</span>
        </div>
        <div class="summary-item flex-1 text-right">
          <span class="label font-666">跟进结果:</span>
          <span class="value font-333" :class="{ 'font-green': self.status === 2 }">{{ self.statusText }}</span>
        </div>
      </div>
      <div class="summary-row row mt8" v-if="self.status !== 2">
        <div class="summary-item flex-1">
          <span class="label font-666">跟进内容:</span>
          <span class="value font-333">{{ self.followContent }}</span>
        </div>
      </div>
    </div>


    <!-- 沟通情况标题 - 只在已完成/已终止状态显示 -->
    <div v-if="!isPendingFollowUp" class="content-title  mt8 row flex-center">
      <div class="flex-1 font-666">沟通情况:</div>
      <!-- <button class="edit-btn" @click="handleEdit">
          <span class="edit-text" >修改</span>
       </button> -->
    </div>

    <!-- 详细跟进内容区域 - 只在已完成/已终止状态显示 -->
    <div v-if="!isPendingFollowUp" class="content-section font-333 mt2">
      {{ self.remark }}
    </div>

    <!-- 记录跟进情况按钮 - 只在待跟进状态显示 -->
    <div v-if="isPendingFollowUp">
      <div class="record-btn" @click="recordFollowUp">记录跟进情况</div>
    </div>
  </div>
</template>

<script>

import moment from 'moment';

import { todayTodoStore } from '@/store/h5/todayTodo.js'


export default {
  name: 'FollowUpTask',
  props: {
    // 任务数据，支持从父组件传入
    self: {
      type: Object,
      default() {
        return {

        }
      }
    }
  },
  data() {
    return {

    }
  },

  computed: {
    // 判断是否为待跟进状态
    isPendingFollowUp() {
      const currentDate = moment().format('YYYY-MM-DD');
      const followDate = this.self.followDate;
      // 状态为待跟进（status === 1）且跟进时间小于等于今日
      return this.self.status === 1 && followDate <= currentDate;
    }
  },
  mounted() {

  },
  methods: {
    // 记录跟进情况方法，跳转到注册页面
    recordFollowUp() {
      const todayTodoStoreInstance = todayTodoStore()
      todayTodoStoreInstance.setCurrentFollowUp(this.self)
      this.$router.push('/todayTodo/register?status=1');
    },
    // 修改跟进内容方法
    handleEdit() {
      const todayTodoStoreInstance = todayTodoStore();
      todayTodoStoreInstance.setCurrentFollowUp(this.self)
      this.$router.push('/todayTodo/create?status=2');
      // this.$router.push('/todayTodo/register?status=2');
    }
  }
}
</script>

<style lang="scss" scoped>
.follow-up-task {
  // 卡片容器样式：白色背景、圆角、内边距
  background-color: #fff;
  border-radius: 3.984px;
  padding: 12px;
  margin-bottom: 12px;
  text-align: left;
  box-sizing: border-box;

  // 顶部概述区域
  .summary-section {
    .summary-row {
      // 确保两列之间有间距，使用 justify-content 来分布空间
      justify-content: space-between;
      align-items: flex-start;
    }

    .summary-item {
      // 确保内容左对齐（第一列）或右对齐（第二列）
      display: flex;
      align-items: center;

      &.text-right {
        text-align: right;
        justify-content: flex-end;
      }

      .label {
        // 标签样式：浅灰色，标签和值之间已有冒号，这里只需要设置颜色和字体大小
        font-size: .25rem;
        min-width: 1.25rem;
      }

      .value {
        // 值样式：深灰色，值紧跟在标签冒号后面
        font-size: .25rem;
        margin-left: 2.016px; // 标签和值之间的间距
        word-break: break-all;
      }
    }
  }

  // 跟进内容标题
  .content-title {
    font-size: .25rem;
    font-weight: normal;
    line-height: 1.5;

    .edit-btn {
      background: none;
      border: none;
      color: #28b8c3;
      font-size: .25rem;
      cursor: pointer;
      padding: 0;

    }
  }

  // 详细跟进内容区域
  .content-section {
    font-size: .25rem;
    line-height: 1.6;
    word-break: break-all;
    white-space: pre-wrap;
    // 确保文本可以自动换行显示完整内容
    overflow-wrap: break-word;
  }

  .record-btn {
    width: 5rem;
    background-color: #fff;
    color: #28b8c3;
    border: 1px solid #28b8c3;
    padding: .167rem 0;
    border-radius: 0.083rem;
    text-align: center;
    font-size: .25rem;
    cursor: pointer;
    margin: 0 auto;
    margin-top: .417rem;
  }
}
</style>